/** The short symbol a donor reads next to an amount in `currency` ('€', '£', '$'), or the code when it has none. */
export function currencySymbol(locale: string, currency: string): string {
	try {
		const parts = new Intl.NumberFormat(locale, {
			style: 'currency',
			currency,
			currencyDisplay: 'narrowSymbol',
		}).formatToParts(0);
		return parts.find((part) => part.type === 'currency')?.value ?? currency;
	} catch {
		// `Intl` throws on a code it does not know; the code itself still says what the amount is in.
		return currency;
	}
}
